module.exports = __webpack_public_path__ + "img/vertical_7_2_3.defd5930.png";